import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getAll } from 'data/company/datasources/companyPrivacyConfig.datasource';
import { CompanyPrivacyConfig } from 'data/company/schemas';

export function useCompanyPrivacyConfig() {
    return useQuery<CompanyPrivacyConfig[], AxiosError>({
        queryKey: ['company-privacy-config'],
        queryFn: async ({ signal }) =>
            (await getAll(undefined, signal)).data.result_list ?? [],
        retry: 0
    });
}
